import { render, staticRenderFns } from "./CreateProcessGroup.vue?vue&type=template&id=0b230a0a&"
import script from "./CreateProcessGroup.vue?vue&type=script&lang=js&"
export * from "./CreateProcessGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports